import { RootState } from "@app/types"
import { useUnleashClient, useUnleashContext } from "@unleash/proxy-client-react"
import { useEffect } from "react"
import { useSelector } from "react-redux"

const SyncUnleashContextWithUser = () => {
    const client = useUnleashClient()
    const updateContext = useUnleashContext()
    const memberId = useSelector(
        (state: RootState) => state.user.data?.currentMember?.memberId ?? undefined,
    )
    const userIsLoading = useSelector((state: RootState) => state.user.loading)

    useEffect(() => {
        if (userIsLoading) {
            return
        }

        const currentProperties = client.getContext().properties ?? {}
        const nextProperties = { ...currentProperties }
        const unleashUserId = memberId || undefined
        const unleashMemberId = memberId || undefined

        // Expose the same app identity in two Unleash fields:
        // - userId: built-in context field
        // - properties.memberId: custom context field configured in Unleash
        if (unleashMemberId) {
            nextProperties.memberId = unleashMemberId
        } else {
            delete nextProperties.memberId
        }

        void updateContext({
            userId: unleashUserId,
            properties: Object.keys(nextProperties).length > 0 ? nextProperties : undefined,
        })
    }, [client, memberId, updateContext, userIsLoading])

    return null
}

export default SyncUnleashContextWithUser
